class SEO {
    constructor(apiConfig, http) {
        const { siteInfo } = apiConfig;
        const { storeId } = siteInfo;
        this.apiConfig = apiConfig;
        this.http = http;
        this.path = `/wcs/resources/store/${storeId}/seo`;
    }

    get(template, vanityUrl, config = {}) {
        const params = {
            path: vanityUrl
        };
        return this.http.get(`${this.path}/${template}`, { params, ...config })
            .then(resp => {
                const { data, status } = resp;
                //attempt to parse response
                if (status === 200 && data && data !== '') {
                    return data;
                } else {
                    return Promise.reject({})
                }
            });
    }

}

export default SEO;


